export default {
  name: 're-success',
  props: {
    containerClass: {
      type: [String, Array, Object],
      default: ''
    },
    title: {
      type: String,
      default: 'Success'
    },
    message: {
      type: String,
      default: 'The operation was successful'
    },
    buttonTitle: {
      type: String,
      default: 'Ok'
    },
    buttonClasses: {
      type: [String, Array, Object],
      default: null
    }
  },
  methods: {
    successClick() {
      this.$emit('close');
    }
  },
}
